import { render } from "./CartItems.vue?vue&type=template&id=780151b2&ts=true"
import script from "./CartItems.vue?vue&type=script&lang=ts"
export * from "./CartItems.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__